import { useQuery } from '@tanstack/react-query';
import { backendServices } from '../services';

export function useBuyerPortalSettings({ companyId, enabled = true }: { companyId: number | null; enabled?: boolean }) {
    const query = useQuery(
        ['BuyerPortalSettings', companyId],
        async () => {
            const api = new backendServices.Apis.CompanyApi();
            const res = await api.getBuyerPortalSettings({ companyId: companyId! });

            return res.data;
        },
        {
            enabled: enabled && !!companyId,
            staleTime: Infinity,
            cacheTime: Infinity,
        }
    );

    return query;
}
